module.exports = __webpack_public_path__ + "images/bmwcd845adc2680ba92de4c19c0bb36f64a.png";